export default __webpack_public_path__ + "static/media/ic_nepal.c667f722.svg";